module.exports = __webpack_public_path__ + "static/1-e159930da6081deb1e983c529cea8a6c.png";